/** Docs shell color mode. */
export type DocsTheme = 'light' | 'dark';

const STORAGE_KEY = 'nrx-ui-docs-theme';

/** Resolve the initial theme from storage or system preference. */
export function resolveDocsTheme(stored: string | null): DocsTheme {
  if (stored === 'dark' || stored === 'light') return stored;
  if (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
  ) {
    return 'dark';
  }
  return 'light';
}

/** Read persisted theme preference. */
export function getStoredDocsTheme(): DocsTheme {
  if (typeof window === 'undefined') return 'light';
  return resolveDocsTheme(localStorage.getItem(STORAGE_KEY));
}

/** Apply theme to the document root and persist the choice. */
export function applyDocsTheme(theme: DocsTheme): void {
  document.documentElement.dataset['theme'] = theme;
  document.documentElement.style.colorScheme = theme;
  localStorage.setItem(STORAGE_KEY, theme);
}
